import { render } from "./AuctionCard.vue?vue&type=template&id=06e6579e&scoped=true"
import script from "./AuctionCard.vue?vue&type=script&lang=js"
export * from "./AuctionCard.vue?vue&type=script&lang=js"

import "./AuctionCard.vue?vue&type=style&index=0&id=06e6579e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e6579e"]])

export default __exports__